import { render } from "./Artist.vue?vue&type=template&id=cef41488&scoped=true"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"

import "./Artist.vue?vue&type=style&index=0&id=cef41488&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef41488"]])

export default __exports__